import { render, staticRenderFns } from "./AuthorSummary.vue?vue&type=template&id=182210ba"
import script from "./AuthorSummary.vue?vue&type=script&lang=js"
export * from "./AuthorSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports